import Controller from '@ember/controller';
import QueryParams from 'eflex/constants/bi-query-params';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { andonReports } from 'eflex/constants/bi-report-options';
export default class BiProductionController extends Controller {
  @tracked stationFilter = null;
  @tracked drawerCollapsed = false;
  @tracked stationIds = [];
  @tracked refresher = false;
  queryParams = [...Object.keys(QueryParams), 'stationFilter'];
  selectedReport = andonReports.stationSummary;

  get reportOptions() {
    return Object.values(andonReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      stationIds: [],
      stationFilter: null,
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
}
